import React from "react";
import { ITotoGameTableType } from "@/types/GlobalTypes";

export default class M17 extends React.Component<ITotoGameTableType> {
	shouldComponentUpdate(nextProps) {
		const
			{ apiKey, nickname, sessionToken, operatorId, uid, lang } = this.props.userdata.user,
			{
				apiKey: newApiKey,
				nickname: newNickname,
				sessionToken: newSessionToken,
				operatorId: newOperatorId,
				uid: newUid,
				lang: newLang
			} = nextProps.userdata.user;

		return (
			apiKey !== newApiKey ||
			nickname !== newNickname ||
			sessionToken !== newSessionToken ||
			operatorId !== newOperatorId ||
			uid !== newUid ||
			lang !== newLang
		);
	}

	render() {
		const
			{ userdata, data: activeGame } = this.props,
			{ link, pcode } = activeGame,
			{ token_sid, lang } = userdata.user;

		const params = [
			`token_sid=${token_sid}`,
			`lang=${lang}`,
			`pcode=${pcode}`
		].join("&"),
			fullLink = link + "?" + params;

		return (
			<iframe src={fullLink} className="content-gamev5" title="Content Game" />
		)
	}
}
